<template>
    <div class="topcenter_wrap" style="padding: 12px 20px;height: 100%;box-sizing: border-box;">
      <div class="top common-small-size top__xTFkw" style="height: 72%;">
        <div class="outer__MGD1w">
          <div class="outerWrapper__9DXZu">
            <span>在制工单计划数</span>
            <div class="processing__zZ_zY common-size-part">{{centerData.runningOrderPlanNum}}</div>
            <div class="splitLine__mzlZC"></div>
          </div>
          <div class="outerWrapper__9DXZu">
            <span>在制工单延期数</span>
            <div class="delay__QU3I9 common-size-part">{{centerData.runningOrderOverTimeNum}}</div>
            <div class="splitLine__mzlZC"></div>
          </div>
          <div class="outerWrapper__9DXZu">
            <span>今日完成工单数</span>
            <div class="complete__Mu44i common-size-part">{{centerData.todayCompletedOrderNum}}</div>
            <div class="splitLine__mzlZC"></div>
          </div>
          <div class="outerWrapper__9DXZu">
            <span>今日工单产出数</span>
            <div class="complete__Mu44i common-size-part">{{centerData.todayCompletedGoodNum}}</div>
          </div>
        </div>
        <div class="inner__ReC7U">
          <span>在制工单数</span>
          <div class="processing__zZ_zY common-size-part">{{centerData.runningOrderNum}}</div>
        </div>
        <div class="inner__ReC7U">
          <span>在制任务数</span>
          <div class="processing__zZ_zY common-size-part">{{centerData.runningTaskNum}}</div>
        </div>
        <div class="outer__MGD1w">
          <div class="outerWrapper__9DXZu">
            <span>在制任务计划数</span>
            <div class="processing__zZ_zY common-size-part">{{centerData.runningTaskPlanNum}}</div>
            <div class="splitLine__mzlZC"></div>
          </div>
          <div class="outerWrapper__9DXZu">
            <span>在制任务延期数</span>
            <div class="delay__QU3I9 common-size-part">{{centerData.runningTaskOverTimeNum}}</div>
            <div class="splitLine__mzlZC"></div>
          </div>
          <div class="outerWrapper__9DXZu">
            <span>今日完成任务数</span>
            <div class="complete__Mu44i common-size-part">{{centerData.todayCompletedTaskNum}}</div>
            <div class="splitLine__mzlZC"></div>
          </div>
          <div class="outerWrapper__9DXZu">
            <span>今日不良品率</span>
            <div class="delay__QU3I9 common-size-part">{{centerData.todayNongoodRate}}%</div>
          </div>
        </div>
      </div>
      <div class="bottom common-small-size bottom__GJxhZ" style="display: flex;">
        <div class="realtime__R7Yip"></div>
        <div class="tableoOut common-small-size rollingMessage__cr1mw" ref="tableoOut">
            <div class="tableBox" ref="tableBox"
                :style="{height: tableHei,marginTop: '10px'}">
                <div class="tableInner" ref="tableInner">
                    <div class="box" v-for="(item,index) in tableDataScroll" :key="index">
                        <div class="circle"></div>
                        <div class="name" style="width: 25%;" :title="item.updateTime">{{item.updateTime}}</div>
                        <div class="name" style="width: 20%;" :title="item.creater">{{item.creater}}</div>
                        <div class="name" style="width: 25%;" :title="item.baseInfo.processName">{{item.baseInfo.processName}}</div>
                        <div class="name" style="width: 30%;" :title="item.baseInfo.orderCode">{{item.baseInfo.orderCode}}</div>
                    </div>
                </div>
                <!-- 两个相同的容器 实现无缝衔接 -->
                <div class="tableInner" v-if="size < tableDataScroll.length">
                  <div class="box" v-for="(item,index) in tableDataScroll" :key="'1'+index">
                      <div class="circle"></div>
                      <div class="name" style="width: 25%;" :title="item.updateTime">{{item.updateTime}}</div>
                      <div class="name" style="width: 20%;" :title="item.creater">{{item.creater}}</div>
                      <div class="name" style="width: 25%;" :title="item.baseInfo.processName">{{item.baseInfo.processName}}</div>
                      <div class="name" style="width: 30%;" :title="item.baseInfo.orderCode">{{item.baseInfo.orderCode}}</div>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
</template>
<script>
import { getOrderInfo,enterGetList} from '@/api/basicData';

export default {
  data() {
    return {
      tableHei: 'auto',
      timer: null,
      size: 0,
      stopSign: true, // 判断定时器是否停止标识
      stepTime: null, // 改为全局定时器
      tableHeight:20,
      userData:JSON.parse(window.localStorage.getItem('userdata')),
      tableDataScroll:[],
      pageNo: 1, // 页码
      pageSize: 20, // 一页20条
      centerData:{},
      timer1:null,
    }
  },
  mounted() {
    this.getOrderInfo()
    this.enterGetList()
    this.timer1 = setInterval(() => {
      this.getOrderInfo();
      this.enterGetList();
    }, 10000)

    this.$nextTick(function(){
        const that = this;
        // 增加浏览器激活状态判断。非激活状态为onblur
        window.onfocus = function(e) {
            const tableBox = that.$refs.tableBox;
            if(!!tableBox){
              const sT = tableBox.scrollTop;
              if (!that.stopSign) {
                  tableBox.scrollTop = Math.round(sT / this.tableHeight) * this.tableHeight;
                  clearInterval(that.stepTime);
              }
            }
        }
        this.getTable();
      })

  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    if(this.timer1){
      clearInterval(this.timer1);
    }
  },
  methods: {
    enterGetList(){
      var params = {
        condition: {
          factoryId: this.userData.factoryId,
        },
        currentPage: this.pageNo,
        pageSize: this.pageSize,
      }
      enterGetList(params).then(res => {
        if(res.code == 200){
          this.tableDataScroll = []
          let list = res.data.list
          for (let i = 0; i < list.length; i++) {
            this.tableDataScroll.push(list[i]);
          }
        }else{
          this.$message.error(res.msg)
        }
      }).catch(err => {
        this.$message.error(err)
      })
    },
    async getOrderInfo(){
      var data = {
        factoryId:this.userData.factoryId
      }
      await getOrderInfo(data).then(res => {
        if(res.code == 200){
          if(res.data){
            this.centerData = res.data
          }
        }else{
          this.$message.error('查询失败！')
        }
        this.loading = false
      })
      .catch(err => {
        this.loading = false
        this.$message.error(err)
      })
    },
    getTable() {
        const outHei = this.$refs.tableoOut.clientHeight;
        this.size = Math.floor(outHei / this.tableHeight);
        this.tableHei = this.size * this.tableHeight + 'px';
        this.scrolls();
    },
    stepScroll() {
        const that = this;
        const step = this.tableHeight;
        let num = 0;
        const tableBox = this.$refs.tableBox;
        // 改为全局定时器，且在调用前先进行清空
        clearInterval(this.stepTime);
        this.stepTime = setInterval(function () {
            that.stopSign = false;
            num += 2;
            if (num > step) {
                num = 0;
                clearInterval(that.stepTime);
                that.stopSign = true;
            } else {
              if(tableBox){
                tableBox.scrollTop += 2;
              }
            }
        }, 1000 / 60);
    },
    scrolls() {
        const that = this;
        const tableBox = this.$refs.tableBox;
        const tableInner = this.$refs.tableInner;
        clearInterval(this.timer);
        this.timer = setInterval(function () {

            // 修改定时器结束判断条件
            if(tableBox && tableBox.scrollTop >= tableInner.scrollHeight) {

                tableBox.scrollTop = 0;
            }
            that.stepScroll();
        }, 2000);
    },
  }
}
</script>
<style scoped>
.topcenter_wrap .top{
  width: 100%;
  height: 75%;
  margin-bottom: 3%;
}
.topcenter_wrap .common-small-size{
  font-size: 12px;
  color: #fff;
}
.outerWrapper__9DXZu{
  position: relative;
  height: 25%;
  min-height: 60px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 15px;
}
.processing__zZ_zY{
  color: #76f2ac;
}
.splitLine__mzlZC{
  position: absolute;
  right: 0;
  bottom: 5px;
  left: 0;
  width: calc(100% - 25px);
  margin: auto;
  border-bottom: 1px solid rgba(4,249,254,.4);
}
.outer__MGD1w{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  min-height: 230px;
  position: relative;
}
.delay__QU3I9{
  color: #fb6583;
}
.complete__Mu44i{
  color: #04f9fe;
}
.common-size-part{
  font-size: 20px;
  font-family: "JetBrains";
  font-feature-settings: "zero";
  font-variant-numeric: slashed-zero;
  margin-top: 4px;
}
.inner__ReC7U{
  height: 25%;
  min-height: 60px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 15px;
  position: relative;
}
.inner__ReC7U, .outer__MGD1w{
  width: 20%;
  background-color: rgba(0,25,48,.6);
  border: 1px solid #04f9fe;
  border-radius: 2px;
}
.top__xTFkw{
  display: flex;
  flex: 3 1;
  flex-direction: row;
  justify-content: space-between;
}


 /* 滚动表格最外层 */
 .tableoOut {
    max-height: 90px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}
.tableBox {
    width: 100%;
    overflow: hidden
}
.tableTit {
    width: 100%;
    height: 40px;
    color: #858A84;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
}
.tableInner {
    height: auto;
}
.box {
    width: 100%;
    height: 20px;
    display: flex;
    color: #fff;
}
.tableoOut .addr, .tableoOut .time, .tableoOut .name {
    box-sizing: border-box;
    padding: 0 5px;
    text-align: left;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.tableoOut .addr {
    width: calc(100% - 200px);
    flex-shrink: 0;
}
.tableoOut .name {
    flex-shrink: 0;
}
.bottom__GJxhZ{
  position: relative;
  width: 100%;
  height: 22%;
  background-color: rgba(0,25,48,.6);
  border: 1px solid #04f9fe;
  border-radius: 2px;
}
.container__2hNoW .content__gmzNb .bottom__GJxhZ{
  display: flex;
  flex: 2 1;
  flex-direction: row;
  justify-content: space-between;
}
.rollingMessage__cr1mw{
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
}
.circle{
  display: inline-block;
  width: 7px;
  height: 7px;
  border: 3px solid #04f9fe;
  border-radius: 50%;
  box-sizing: border-box;
  margin-top: 2px;
}
.realtime__R7Yip{
  position: relative;
  width: 15px;
  left: 4px;
  border-right: 1px solid #04f9fe;
}
.outer__MGD1w:after,
.inner__ReC7U:after{
  position: absolute;
  bottom: 0;
  left: 0;
  border-right: 8px solid transparent;
  border-bottom: 8px solid #04f9fe;
  content: "";
}
.inner__ReC7U:before, .outer__MGD1w:before{
  position: absolute;
  top: 0;
  right: 0;
  border-top: 8px solid #04f9fe;
  border-left: 8px solid transparent;
  content: "";
}
</style>



// WEBPACK FOOTER //
// src/views/workshopSignage/workshopSignage/components/topcenter.vue